customElements.get("main-product-gallery") ||
  customElements.define(
    "main-product-gallery",
    class extends HTMLElement {
      constructor() {
        super();
        this.mainCarouselSelector = "#main-carousel";
        this.thumbnailCarouselSelector = "#thumbnail-carousel";
        this.variants = this.getVariants();
        this.init();
        this.syncedVariantImage = this.dataset.syncedVariantImage;
        this.variantShouldTrigger = true;
      }

      connectedCallback() {
        subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
      }

      init() {
        this.convertVariantsToArray();

        // ─── Main Slider ───────────────────────────────────────────────
        this.mainSlider = new Splide(
          this.querySelector(this.mainCarouselSelector),
          {
            type: "loop",
            rewind: true,
            pagination: false,
            arrows: false,         // Pakai custom arrows kita sendiri
            autoHeight: false,
            perPage: 1,
            speed: 600,
            easing: "cubic-bezier(0.25, 1, 0.5, 1)",
          }
        );

        // ─── Thumbnail: show/hide di mobile ───────────────────────────
        const thumbnailEl = this.querySelector(this.thumbnailCarouselSelector);
        const isMobile = window.matchMedia("(max-width: 600px)").matches;
        const hideMobile = thumbnailEl.dataset.showArrowsMobile === "hide";

        if (isMobile && hideMobile) {
          thumbnailEl.classList.add("hidden");
        } else {
          thumbnailEl.classList.remove("hidden");
        }

        // ─── Thumbnail Slider ──────────────────────────────────────────
        this.thumbnailSlider = new Splide(thumbnailEl, {
          perPage: 5,
          gap: 10,
          pagination: false,
          dragMinThreshold: 10,
          isNavigation: true,
          arrows: thumbnailEl.dataset.showArrows === "true",
          classes: {
            arrow: "slider-button splide__arrow",
          },
          speed: 400,
          easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        });

        // ─── Sync Main ↔ Thumbnail ────────────────────────────────────
        this.mainSlider.sync(this.thumbnailSlider);

        // ─── Wire custom arrow buttons ────────────────────────────────
        this.prevArrow = this.querySelector(".main-gallery__arrow--prev");
        this.nextArrow = this.querySelector(".main-gallery__arrow--next");

        if (this.prevArrow) {
          this.prevArrow.addEventListener("click", () => {
            this.mainSlider.go("<");
          });
        }
        if (this.nextArrow) {
          this.nextArrow.addEventListener("click", () => {
            this.mainSlider.go(">");
          });
        }

        // ─── Set height saat pertama mount ────────────────────────────
        this.mainSlider.on("mounted", () => {
          const index = this.mainSlider.index;
          const slides = this.mainSlider.Components.Elements.slides;
          const slide = slides[index];

          if (slide) {
            const height =
              slide.querySelector("img")?.offsetHeight ||
              slide.querySelector("video")?.offsetHeight ||
              0;
            this.style.setProperty("--active-slide-height", `${height}px`);
          }

          // Sembunyikan arrow jika cuma 1 gambar
          if (slides.length <= 1) {
            const wrapper = this.querySelector(".main-gallery-wrapper");
            wrapper?.classList.add("main-gallery--single");
          }
        });

        // ─── Mount ────────────────────────────────────────────────────
        this.mainSlider.mount();
        this.thumbnailSlider.mount();

        // ─── Update height SETELAH animasi selesai ────────────────────
        this.mainSlider.on("moved", (newIndex) => {
          const slides = this.mainSlider.Components.Elements.slides;
          if (!slides) return;
          const slide = slides[newIndex];
          if (!slide) return;
          const height =
            slide.querySelector("img")?.offsetHeight ||
            slide.querySelector("video")?.offsetHeight ||
            0;
          this.style.setProperty("--active-slide-height", `${height}px`);
        });

        // ─── Sync variant saat thumbnail diklik ───────────────────────
        this.thumbnailSlider.on("moved", (newIndex) => {
          if (!Debutify.settings.dbtfy_variant_sync_on_media) return;

          if (!this.variantShouldTrigger) {
            this.variantShouldTrigger = true;
            return;
          }

          this.variantShouldTrigger = true;

          const mediaId =
            this.thumbnailSlider.Components.Elements.slides[newIndex]
              ?.dataset.mediaId;
          const options = this.variants?.[mediaId] || null;

          if (options) {
            this.syncedVariantImage = "false";
            const fieldsets = this.closest("product-info").querySelectorAll(
              "variant-selects fieldset"
            );
            options.forEach((value, i) => {
              const fieldset = fieldsets[i];
              if (fieldset) {
                const input = fieldset.querySelector(`input[value="${value}"]`);
                if (input) {
                  input.checked = true;
                  input.dispatchEvent(new Event("change", { bubbles: true }));
                }
              }
            });
            this.syncedVariantImage = "true";
          }
        });
      }

      getVariants() {
        const productInfo = this.closest("product-info");
        const raw = productInfo?.querySelector(
          "variant-selects [data-product-variants]"
        )?.innerHTML;
        return raw ? JSON.parse(raw) : null;
      }

      convertVariantsToArray() {
        if (!this.variants) return;
        this.variants = Object.entries(this.variants)
          .filter(([, v]) => v.featured_media?.id)
          .reduce((acc, [, variant]) => {
            acc[variant.featured_media.id] = variant.options;
            return acc;
          }, {});
      }

      handleVariantChange({ data: { variant } }) {
        if (!variant.featured_media || this.syncedVariantImage !== "true") return;

        const mediaId = variant.featured_media.id;
        let position = this.querySelector(this.thumbnailCarouselSelector)
          ?.querySelector(`[data-media-id='${mediaId}']`)
          ?.dataset.position;

        if (position) {
          position = parseInt(position) - 1;
          if (position !== this.thumbnailSlider.index) {
            this.variantShouldTrigger = false;
            this.thumbnailSlider?.go(position);
          }
        }
      }
    }
  );
